//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuoteIcon from '~/assets/img/quote.svg?inline'
export default {
  name: 'GetStartedTestimonials',

  components: {
    QuoteIcon
  },

  props: {
    color: {
      type: String,
      default: ''
    },

    textColor: {
      type: String,
      default: '#333'
    }
  },

  data: () => ({
    testimonials: [
      {
        content:
          'Goodness packed into pretty little bottles! HUM has turned taking vitamins into something that feels like a treat.',
        author: 'Bela Sorin'
      },
      {
        content:
          'Loved the personalized suggestions and having it shipped to my house made life so easy. The cost when you buy 3 is also less than buying high quality vitamins at the store.',
        author: 'Adam Burgess'
      },
      {
        content:
          'Been using HUM for 2 months now and I love it! My body never felt better, my skin is clearer and my overall health is feeling great',
        author: 'Tiffany Pulvino'
      },
      {
        content:
          "I've been taking HUM products for a month now and can already tell a different in my gut health. Less bloating and clearer/glowing skin. In love and can't wait for my next order!",
        author: 'Rachel Kim'
      },
      {
        content:
          'I have seen so many changes since taking HUM. I feel better, my skin looks better, my hair is growing, my nails are getting stronger and I feel so much energy. Wow!',
        author: 'Selena Ramos'
      },
      {
        content:
          'I love how easy and convenient it is to order my vitamins. I love that I can change my box or the date of my shipment anytime!',
        author: 'Sarah Almeida'
      },
      {
        content:
          'One month of taking HUM and my skin has never looked better! I have even received unsolicited compliments on my complexion. I am thrilled with how these supplements work!',
        author: 'Laurain Salga'
      },
      {
        content:
          "I'm so pleased with the results I've had so far and I feel amazing! I have been telling everyone I care for to try it for themselves because they deserve to experience it as well.",
        author: 'Erik Najera'
      },
      {
        content:
          'I absolutely love my HUM Vitamins. I have been using them for about a month now and I am starting to notice changes in my energy, hair, nails and just overall appearance.',
        author: 'Chay Muller'
      },
      {
        content:
          'I absolutely LOVE these products!! My skin, hair and nails are growing so strong and my digestive system has never been so efficient!',
        author: 'Emilee Wagner'
      },
      {
        content:
          'I love the all natural ingredients and transparency. Also getting 15% off every time you order three makes it rather affordable!',
        author: 'Felicia Larman'
      },
      {
        content:
          'Never knew that putting natural ingredients in my body could feel SO empowering. Every time I take them, I feel like I take another step toward my health and overall wellness.',
        author: 'Alina Brassard'
      }
    ],
    options: {
      slidesPerView: 1,
      simulateTouch: false,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true
      },
      breakpointsInverse: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    }
  }),

  computed: {
    quoteColor() {
      return { color: this.color || '#e10098' }
    }
  }
}
